// Enums
export const TransactionableTypeEnum = {
  STARTING_BALANCE: "STARTING_BALANCE",
  GOODS_RECEIPT_PRODUCT_VARIANT: "GOODS_RECEIPT_PRODUCT_VARIANT",
  DELIVERY_ORDER_PRODUCT_VARIANT: "DELIVERY_ORDER_PRODUCT_VARIANT",
  PURCHASE_RETURN_PRODUCT_VARIANT: "PURCHASE_RETURN_PRODUCT_VARIANT",
  SALES_RETURN_PRODUCT_VARIANT: "SALES_RETURN_PRODUCT_VARIANT",
  CUSTOMER_CLAIM_PRODUCT_VARIANT: "CUSTOMER_CLAIM_PRODUCT_VARIANT",
  STOCK_ADJUSTMENT: "STOCK_ADJUSTMENT",
  EXPENSE_ACCRUAL: "EXPENSE_ACCRUAL",
  OTHER_PAYMENT: "OTHER_PAYMENT",
  STOCK_RESET: "STOCK_RESET",
  // Add more types here as needed
};

// Human-readable names for transaction types
const transactionNameMap = {
  [TransactionableTypeEnum.STARTING_BALANCE]: "Saldo Awal",
  [TransactionableTypeEnum.GOODS_RECEIPT_PRODUCT_VARIANT]: "Penerimaan Barang",
  [TransactionableTypeEnum.DELIVERY_ORDER_PRODUCT_VARIANT]: "Pengiriman Barang",
  [TransactionableTypeEnum.PURCHASE_RETURN_PRODUCT_VARIANT]: "Retur Pembelian",
  [TransactionableTypeEnum.SALES_RETURN_PRODUCT_VARIANT]: "Retur Penjualan",
  [TransactionableTypeEnum.CUSTOMER_CLAIM_PRODUCT_VARIANT]: "Klaim Pelanggan",
  [TransactionableTypeEnum.STOCK_ADJUSTMENT]: "Penyesuaian Stok",
  [TransactionableTypeEnum.EXPENSE_ACCRUAL]: "Pencatatan Beban",
  [TransactionableTypeEnum.OTHER_PAYMENT]: "Pembayaran",
  [TransactionableTypeEnum.STOCK_RESET]: "Reset Stok Cut-over",
  // Extend here as needed
};

// Map of reference number prefixes to their paths
const transactionPrefixMap = {
  PO: "procurement/purchase-orders",
  GR: "procurement/goods-receipts",
  PI: "procurement/purchase-invoices",
  PP: "procurement/purchase-payments",
  PDP: "procurement/purchase-down-payments",
  PRT: "procurement/purchase-returns",
  SO: "sales/sales-orders",
  ORD: "sales/sales-orders",
  DO: "sales/delivery-orders",
  SI: "sales/sales-invoices",
  SP: "sales/sales-payments",
  SRT: "sales/sales-returns",
  SA: "inventory/stock-adjustments",
  EA: "expense/expense-accruals",
  OP: "general-ledger/other-payments",
  // Extend here as needed
};

// Known prefixes with no document page: cut-over reset rows (RST-) are maintenance records.
const unlinkedPrefixes = new Set(["RST"]);

// Return readable transaction name from enum
export const getTransactionName = (type) =>
  transactionNameMap[type] || "Transaksi";

// Return route path from a reference number
// For Purchase Orders, orderType is required to determine if it's standard or lab
export const getTransactionPath = (referenceNumber, orderType = null) => {
  if (!referenceNumber) return null;

  const prefix = referenceNumber.split("-")[0];
  if (unlinkedPrefixes.has(prefix)) return null;

  let basePath = transactionPrefixMap[prefix];

  if (!basePath) {
    console.warn(`[getTransactionPath] Unknown transaction prefix: ${prefix}`);
    return null;
  }

  // For Purchase Orders, append /standard or /lab based on orderType
  if (prefix === "PO" && orderType) {
    const orderTypeSubpath = orderType.toLowerCase(); // "STANDARD" -> "standard", "LAB" -> "lab"
    basePath = `${basePath}/${orderTypeSubpath}`;
  }

  return `/${basePath}/${referenceNumber}`;
};
